import React from "react";
import ForgotPasswordSendOtp from "./ForgotPasswordSendOtp";
import VerifyOtp from "../VerifyOtp";
import {
  sendForgotPasswordOtp,
  verifyForgotPasswordOtp,
} from "@/lib/api/auth-actions";
import { toast } from "sonner";
import ForgotPasswordResetPassword from "./ForgotPasswordResetPassword";

const ForgotPassword = () => {
  const [currentStep, setCurrentStep] = React.useState(0);
  const [formData, setFormData] = React.useState<{
    email: string;
    otp: string;
    resetPasswordToken: string;
  }>({
    email: "",
    otp: "",
    resetPasswordToken: "",
  });

  const handleNextStep = (data: Partial<typeof formData>) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setCurrentStep((prev) => prev + 1);
  };

  const steps = [
    {
      title: "Send OTP",
      component: (
        <ForgotPasswordSendOtp key="send-otp" handleNextStep={handleNextStep} />
      ),
    },
    {
      title: "Verify OTP",
      component: (
        <VerifyOtp
          key="verify-otp"
          email={formData.email}
          onSubmit={(otp) => {
            verifyForgotPasswordOtp(formData.email, otp)
              .then((res) => {
                if (res.success) {
                  toast.success(res.message);
                  // Proceed to next step or reset password step
                  handleNextStep({
                    otp,
                    resetPasswordToken: res.data?.resetPasswordToken || "",
                  });
                } else {
                  toast.error(res.message);
                }
              })
              .catch((error) => {
                toast.error(
                  error.message || "Failed to verify OTP. Please try again.",
                );
              });
          }}
          onResentOtp={() => {
            sendForgotPasswordOtp(formData.email)
              .then((res) => {
                if (res.success) {
                  toast.success(res.message);
                  // Proceed to next step or reset password step
                } else {
                  toast.error(res.message || "Failed to resend OTP");
                }
              })
              .catch((error) => {
                console.error("Error resending OTP:", error);
              });
          }}
          onBack={() => {
            setCurrentStep((prev) => prev - 1);
          }}
          length={6}
        />
      ),
    },
    {
      title: "Reset Password",
      component: (
        <ForgotPasswordResetPassword
          key="reset-password"
          resetPasswordToken={formData.resetPasswordToken}
        />
      ),
    },
  ];

  return <div className="mx-auto max-w-md">{steps[currentStep].component}</div>;
};

export default ForgotPassword;
